import { render, staticRenderFns } from "./homeOrder.vue?vue&type=template&id=701e834e&scoped=true"
import script from "./homeOrder.vue?vue&type=script&lang=js"
export * from "./homeOrder.vue?vue&type=script&lang=js"
import style0 from "./homeOrder.vue?vue&type=style&index=0&id=701e834e&prod&lang=less&scoped=true"
import style1 from "./homeOrder.vue?vue&type=style&index=1&id=701e834e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e834e",
  null
  
)

export default component.exports